module.exports = __webpack_public_path__ + "img/Fußspuren.9c57c577.jpg";